
      import { ConsoleLogger, checkLoafSupport } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const statusDiv = document.getElementById("status");
      const slowButton = document.getElementById("slowButton");
      const clearBtn = document.getElementById("clearBtn");

      // Verificar soporte
      if (!checkLoafSupport()) {
        statusDiv.innerHTML =
          '<span style="color: var(--color-danger)">❌ Long Animation Frames API no disponible en este navegador</span>';
      }

      // Configurar Long Animation Frames API
      const loafObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          logger.log("");
          logger.log("═════════════════════════════════════════");
          logger.log("🔍 LONG ANIMATION FRAME DETECTADO");
          logger.log("═════════════════════════════════════════");
          logger.log("");

          // Información del frame
          logger.log("📊 Información del Frame:");
          logger.log(`   • Duration: ${entry.duration}ms`);
          logger.log(`   • Blocking duration: ${entry.blockingDuration}ms`);
          logger.log(`   • Render start: ${entry.renderStart}ms`);
          logger.log(`   • Start time: ${entry.startTime}ms`);
          logger.log("");

          // Scripts ejecutados
          logger.log(`📜 Scripts ejecutados (${entry.scripts.length}):`);
          logger.log("");

          entry.scripts.forEach((script, index) => {
            logger.log(`   Script #${index + 1}:`);
            logger.log(`   ├─ Función: ${script.sourceFunctionName || "(anónima)"}`);
            logger.log(`   ├─ Invocado por: ${script.invoker || "N/A"}`);
            logger.log(`   ├─ URL: ${script.sourceURL || "inline"}`);
            logger.log(`   ├─ Duración: ${script.duration}ms`);
            logger.log(`   ├─ Execution start: ${script.executionStart}ms`);
            logger.log(`   └─ Forced layout: ${script.forcedStyleAndLayoutDuration}ms`);
            logger.log("");
          });

          // Evaluación
          let severity = "good";
          let severityText = "Aceptable";
          if (entry.blockingDuration > 200) {
            severity = "poor";
            severityText = "Crítico";
          } else if (entry.blockingDuration > 100) {
            severity = "needs-improvement";
            severityText = "Alto";
          } else if (entry.blockingDuration > 50) {
            severity = "needs-improvement";
            severityText = "Medio";
          }

          logger.log(`⚠️  Severidad: ${severityText} (${entry.blockingDuration}ms de bloqueo)`);
          logger.log("");
          logger.log("✅ Ahora sabemos exactamente qué causó el frame lento!");
          logger.log("═════════════════════════════════════════");
          logger.log("");

          // Actualizar estado
          statusDiv.innerHTML = `
          <div class="metric ${severity}">
            Frame detectado: ${entry.blockingDuration}ms de bloqueo
            <small style="display: block; font-weight: normal; margin-top: 4px;">
              ${entry.scripts.length} script(s) ejecutado(s)
            </small>
          </div>
        `;
        }
      });

      // Observar long animation frames
      try {
        loafObserver.observe({
          type: "long-animation-frame",
          buffered: true,
        });
        logger.log("👀 Observer de LoAF configurado correctamente");
        logger.log("");
      } catch (e) {
        logger.error("Error al configurar LoAF observer:", e.message);
      }

      // Simular un event handler lento (igual que el ejemplo 01)
      slowButton.addEventListener("click", function handleSlowClick() {
        logger.log("👆 Click detectado, generando frame lento...");
        statusDiv.textContent = "Procesando...";

        // Función 1: Cálculo pesado (150ms)
        heavyCalculation();

        // Función 2: Actualizar UI (50ms)
        updateUserInterface();

        // Función 3: Tracking (30ms)
        trackEvent();

        logger.log("✅ Procesamiento completado");
        logger.log("⏳ Esperando LoAF entry...");
        logger.log("");
      });

      // Las mismas funciones del ejemplo 01
      function heavyCalculation() {
        const start = performance.now();
        while (performance.now() - start < 150) {
          Math.random() * Math.random();
        }
      }

      function updateUserInterface() {
        const start = performance.now();
        while (performance.now() - start < 50) {
          Math.random() * Math.random();
        }
        slowButton.textContent = "Frame lento generado ✓";
        setTimeout(() => {
          slowButton.textContent = "Generar frame lento";
        }, 1000);
      }

      function trackEvent() {
        const start = performance.now();
        while (performance.now() - start < 30) {
          Math.random() * Math.random();
        }
      }

      // Función para mostrar mensaje inicial
      function showInitialMessage() {
        logger.log("👋 Haz clic en el botón para generar un frame lento");
        logger.log("📌 Observa cómo LoAF API nos dice exactamente qué lo causó");
        logger.log("");
      }

      // Limpiar consola
      clearBtn.addEventListener("click", () => {
        logger.clear();
        statusDiv.textContent = "Esperando interacción...";
        showInitialMessage();
      });

      // Mensaje inicial
      showInitialMessage();
    